const mutations = {
  COUNTRIES (store, data) {
    store.countries = data
  },
  COUNTRY (store, data) {
    store.country = data
  },
  IS_SELECT_COUNTRY (store, data) {
    store.isSelectCountry = data
  },
  CITIES (store, data) {
    store.cities = data
  }
}

export default mutations
